import { useMail } from "contexts/mailContext/mailContext";

const useUploadComplete = () => {
  const { getMailMetaData } = useMail();

  const galleryMailLink = getMailMetaData().shortUrl;
  const isSizeValidation =
    getMailMetaData().expectedFilesCount !== getMailMetaData().filesCount;
  // const conditionShowPickerPromo =
  //   showPickerPromo &&
  //   getMailMetaData().IsContainOnlyImages &&
  //   getMailMetaData().filesCount > 100;

  return {
    isSizeValidation,
    galleryMailLink,
  };
};

export default useUploadComplete;
